"use client"
import { useConfig } from "./ConfigProvider"

export default function Brand() {
    const { COMPANY_BRAND } = useConfig()
    return (
        <h1 className="text-xl font-bold mb-[-16px]">
            {COMPANY_BRAND}
        </h1>  
    )
}
